import React, { useContext } from "react";
import { Button, Icon } from "semantic-ui-react";
import ListUsersBroker from "./ListUsersBroker";
import CreateUserBrokerForm from "./CreateUserBrokerForm";
import { RootStoreContext } from "../../../../app/stores/rootStore";

interface IProps {
  id: string;
}

const DashboardUsersBroker: React.FC<IProps> = ({id}) => {
  const rootStore = useContext(RootStoreContext);
  const { openModal } = rootStore.modalStore;

  document.title = "Configuración-Usuarios";
  return (
    <div className="configurationContent">
      
        <Button
          onClick={() => openModal(<CreateUserBrokerForm />, "Crear usuario")}
          color="blue"
        >
          <Icon name="add user" /> Agregar Usuario
        </Button>
        <br />
        <br />
        <ListUsersBroker id={id}/>
    </div>
  );
};

export default DashboardUsersBroker;
